module.exports = __webpack_public_path__ + "img/tuozhan03.85b4e540.png";